import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import assetsManager from "../../assets/assetsmanager/assestsmanager";
import { Globalstate } from "context/context";
import { condition } from "context/condition";
import { API_BASE_URL } from "config";
import LoadingScreen from "component/loadingScreen/LoadingScreen";
import BackButton from "component/backButton/BackButton";
import useIsAbove1200px from "hooks/useIsAbove1200px";
import "./discoverPage.css";
import "./animation.css";

const DiscoveryPage = ({ setUpdateRender }) => {
  const searchParam = new URLSearchParams(window.location.search);
  const { dispatch, state } = Globalstate();
  const isAbove1200px = useIsAbove1200px();
  const [isChecked, setIsChecked] = useState(state?.nudgeFlow ? true : false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleClick = () => {
    if (!isChecked) {
      return;
    }
    storeToken();
  };
  const storeToken = async () => {
    let authToken = localStorage.getItem("authToken");
    const source = searchParam.get("source");
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${API_BASE_URL}/user_addition`,
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json"
      },
      data: { source: source ? source : "ABCD" }
    };
    try {
      await axios(config);
      window.location.reload();
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const search = searchParam.get("param");
    localStorage.setItem("authToken", search);
    if (search) {
      dispatch({
        dispatch: condition.SETAUTHTOKEN,
        payload: "search"
      });
    }
  }, []);

  useEffect(() => {
    let search = localStorage.getItem("authToken");
    const source = searchParam.get("source");
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${API_BASE_URL}/user_identification`,
      headers: {
        Authorization: `Bearer ${search}`,
        "Content-Type": "application/json"
      },
      data: {
        source: source === "service" ? "service" : "ABCD"
      }
    };
    const authUser = async () => {
      try {
        const response = await axios(config);
        if (response.data.user_type) {
          const nudgeFlow = searchParam.get("nf");
          if (nudgeFlow) {
            await storeToken();
          } else {
            dispatch({
              type: condition.SETISFIRSTTIME,
              payload: true
            });
          }
        } else {
          dispatch({
            type: condition.SETRECENTSEARCHES,
            payload: [...new Set(response?.data?.searches)]
          });
          dispatch({
            type: condition.SETCHANNEL,
            payload: [...new Set(response?.data?.searches)]
          });
          setUpdateRender(true);
        }
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        setLoading(false);
      }
    };
    authUser();
  }, [dispatch, navigate]);

  return loading ? (
    <LoadingScreen />
  ) : isAbove1200px ? (
    <div className="dt-discovery-page">
      <div className="dt-left">
        <img src={assetsManager.dtDiscoveryPageBg} alt="" />
      </div>
      <div className="dt-right">
        <div className="dt-right-innerCont">
          <div className="cont">
            <div>
              <p className="text1">
                Hi ! <span>👋</span>
              </p>
              <p className="text1 text2">I am SimpliFi </p>
              <p className="text3">Your AI powered companion.</p>
            </div>
            <div className="content-container">
              <div className="term-conditions">
                <input
                  type="checkbox"
                  checked={isChecked || state?.nudgeFlow}
                  onChange={() => setIsChecked(!isChecked)}
                />
                <p className="text4">
                  By engaging with SimpliFi, you agree to our{" "}
                  <br className="brr" />
                  <a
                    href="https://www.adityabirlacapital.com/app-digital/terms-conditions"
                    alt="terms and conditions"
                    target="_blank"
                    rel="noreferrer"
                    className="term-and-conditions-text"
                  >
                    terms and conditions
                  </a>{" "}
                </p>
              </div>
              {!state?.nudgeFlow && (
                <button
                  disabled={!isChecked}
                  className="content-button"
                  onClick={handleClick}
                >
                  Start Now
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="mobScreen discovery-page mobOverlay">
      <div className="top discovery-page-header">
        {!state?.nudgeFlow && <BackButton />}
        <div className="discovery-page-header-bottom">
          <p className="sub-text">
            Hi ! <span>👋</span>
          </p>
          <p className="sub-text">I am SimpliFi </p>
          <p className="sub-text">Your AI powered companion.</p>
        </div>
      </div>
      <div className="bot">
        <img id="bot-animate" src={assetsManager.botImage} alt="" />
      </div>
      <div className="bottom discovery-page-bottom-container">
        <div className="heading">Let's get started</div>
        <div className="content-container">
          <div className="term-conditions">
            <input
              type="checkbox"
              checked={isChecked || state?.nudgeFlow}
              onChange={() => setIsChecked(!isChecked)}
            />
            <p>
              By engaging with SimpliFi, you agree to our <br />
              <a
                href={
                  state?.source === "service"
                    ? "https://uatoneservice.adityabirlacapital.com/channel?request=il2cVNGyvchR8pUuUWHwWnrLr5MxyPIg9CUpDzokt9udbEVu2a0GRIiQ9zdz5AFqpSnF7ttMQL8wUVmQMU2GezVU1svSVusy%2Fq3m%2F3V0A3Pv4sFvLrEZnlpQnncuHUSlDHoYTY72YSn8IvBe%2Fipg9%2BU4UZOhyTObESHq6yuSviEOmfBlgGH6zshlS80F8Q0w2cXRNYWbrhNvB506n%2FJZcsj7GmWYvoAkR%2Bcn4oIsn6DzzmyVJCr%2F%2FfIw8p1rSsj8"
                    : "https://www.adityabirlacapital.com/app-digital/terms-conditions"
                }
                alt="terms and conditions"
                target="_blank"
                rel="noreferrer"
                className="term-and-conditions-text"
              >
                terms and conditions
              </a>{" "}
            </p>
          </div>
          {!state?.nudgeFlow && (
            <button
              disabled={!isChecked}
              className="content-button"
              onClick={handleClick}
            >
              Start Now
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DiscoveryPage;
